// extracted by mini-css-extract-plugin
export default {"root":"root---JFyn0","label":"label---YuR0w"};